import { t } from "ttag";

import {
  getDefaultSize,
  getMinSize,
} from "metabase/visualizations/shared/utils/sizes";
import type { VisualizationDefinition } from "metabase/visualizations/types";

import { getTextCardSettings } from "../shared/text-card-settings";

import { Heading } from "./Heading";

const HeadingViz: VisualizationDefinition = {
  getUiName: () => t`Heading`,
  identifier: "heading",
  iconName: "empty",
  canSavePng: false,

  noHeader: true,
  hidden: true,
  // MetrioniQ: heading cards carry text formatting settings, so they need the
  // "Visualization options" modal that upstream hides for them.
  disableSettingsConfig: false,
  supportPreviewing: false,

  minSize: getMinSize("heading"),
  defaultSize: getDefaultSize("heading"),

  checkRenderable: () => {
    // heading can always be rendered, nothing needed here
  },

  settings: {
    "card.title": {
      dashboard: false,
      getDefault: () => t`Heading card`,
    },
    "card.description": {
      dashboard: false,
    },
    text: {
      getDefault: () => "",
    },
    ...getTextCardSettings({ defaultAlignVertical: "middle" }),
    "dashcard.background": {
      getSection: () => t`Display`,
      // eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
      title: t`Show background`,
      dashboard: true,
      inline: true,
      widget: "toggle",
      // stays false: headings have never had a background, and defaulting to true here
      // would give every existing heading card one on upgrade
      getDefault: () => false,
    },
  },
};

const HeadingWrapper = Object.assign(Heading, HeadingViz);

export { HeadingWrapper as Heading };
